import {EvaluationResult, EvaluationResultRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {COLOR_GRIS} from "../../../../components/layout/colors";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";

export const EvaluationResultListPage = () => {
	const apiManager = useApiManager();
	const ctrl = apiManager.factory(EvaluationResultRestControllerApiFactory);

	const listConfig: AppListConfig<EvaluationResult> = {
		title: "Respuestas de evaluación",
		onClick: "/app/admin/employee/evaluationresult",
		headers: [
			{title: "Nombre"},
			{title: "Nivel", align: "right", width: 120},
		],
		decorator: (bean: EvaluationResult) => (
			< >
				<TableCell style={{color: bean.dismissed ? COLOR_GRIS : ""}}>
					{bean.label}
				</TableCell>
				<TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>
					{bean.level}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			return ctrl.pageEvaluationResult(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};